import { useState, type RefObject } from "react";

export const isOverflowingX = (element: HTMLElement) =>
    element.scrollWidth > element.clientWidth;

export const isOverflowingY = (element: HTMLElement) =>
    element.scrollHeight > element.clientHeight;

/**
 * Props for a `Tooltip` that only shows while its text is cut off. The
 * overflow is measured when Base UI asks to open (after the hover delay), so
 * renders read no layout and a label that fits never opens.
 */
export const useTruncationTooltip = <T extends HTMLElement>({
    ref,
    isTruncated,
}: {
    ref: RefObject<T | null>;
    isTruncated: (element: T) => boolean;
}) => {
    const [isOpen, setIsOpen] = useState(false);

    const onOpenChange = (nextIsOpen: boolean) => {
        const element = ref.current;
        if (nextIsOpen && (element === null || !isTruncated(element))) {
            return;
        }
        setIsOpen(nextIsOpen);
    };

    return { open: isOpen, onOpenChange };
};
